import { render, staticRenderFns } from "./HospitalizationNode.vue?vue&type=template&id=3c937d0d&scoped=true&"
import script from "./HospitalizationNode.vue?vue&type=script&lang=js&"
export * from "./HospitalizationNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c937d0d",
  null
  
)

export default component.exports